import React from 'react';

import { CheckmarkIcon } from '@/components/ui/CheckmarkIcon';

interface SelectCircleProps {
  checked: boolean;
  disabled?: boolean;
  className?: string;
}

/**
 * The drawn circle for picking people or items in a list; consent and settings
 * checkboxes stay square. Decoration only: the caller owns the control, its
 * role and its state.
 */
export function SelectCircle({
  checked,
  disabled = false,
  className = '',
}: SelectCircleProps) {
  return (
    <span
      aria-hidden="true"
      data-testid="select-circle"
      className={`flex h-5 w-5 shrink-0 items-center justify-center rounded-full border-2 ${
        checked
          ? 'border-primary-500 bg-primary-500 text-white dark:border-primary-400 dark:bg-primary-400 dark:text-gray-950'
          : 'border-gray-300 dark:border-gray-600'
      } ${disabled ? 'opacity-50' : ''} ${className}`}
    >
      {checked ? <CheckmarkIcon className="h-3.5 w-3.5" /> : null}
    </span>
  );
}

export default SelectCircle;
